export const mergeObjects = (obj1: any, obj2: any) => {
  let merged: any = { ...obj1, ...obj2 };
  if (Array.isArray(obj1) || Array.isArray(obj2)) {
    merged = [...new Set([...obj1, ...obj2])];
  }

  Object.keys(obj1).forEach((key) => {
    if (obj1[key] && obj2[key] && typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      merged[key] = mergeObjects(obj1[key], obj2[key]);
    }
  });

  return merged;
};
